import { render, staticRenderFns } from "./BirthdayForestEmptyState.vue?vue&type=template&id=2a49104c&scoped=true&"
import script from "./BirthdayForestEmptyState.vue?vue&type=script&lang=ts&"
export * from "./BirthdayForestEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./BirthdayForestEmptyState.vue?vue&type=style&index=0&id=2a49104c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49104c",
  null
  
)

export default component.exports